import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { AssetPreload } from './components'
import { QuizQuestionContext, useQuizQuestionContextValue } from './contextAPI'
import { PATH_URL } from 'src/helpers'
import { MetBefore } from './components/MetBefore/MetBefore'
import { EndQuiz } from './components/EndQuiz'
import { MetBeforeAfterSubmitted } from './components/MetBeforeAfterSubmitted/MetBeforeAfterSubmitted'
import { ColorPalettePage } from './pages/ColorPalettePage'
import { YourDetailsPage } from './pages/YourDetailsPage'
import { NewPlanningStagePage } from './pages/NewPlanningStagePage'
import { GuestCountPage } from './pages/GuestCountPage'
import { NewAvailabilityPage } from './pages/NewAvailabilityPage'
import { NewBudgetPage } from './pages/NewBudgetPage'
import { ContactInfoPage } from './pages/ContactInfoPage'
import { EssentialsCollectionPage } from './pages/EssentialsCollectionPage'
import { PinterestAvailabilityPage } from './pages/PinterestAvailabilityPage'
import { PinterestLinkYourBoardPage } from './pages/PinterestLinkYourBoardPage'
import { PinterestBoardPage } from './pages/PinterestBoardPage'
import { PinterestImportPinsPage } from './pages/PinterestImportPinsPage'

export const QuizQuestion: React.FC = () => {
  const quizQuestionContextValue = useQuizQuestionContextValue()
  return (
    <QuizQuestionContext.Provider value={quizQuestionContextValue}>
      <AssetPreload>
        <Switch>
          <Route path={PATH_URL.EXISTING_PROPOSAL_AFTER_SUBMITTED} component={MetBeforeAfterSubmitted} />
          <Route path={PATH_URL.EXISTING_PROPOSAL} component={MetBefore} />
          <Route path={PATH_URL.QUIZ_END} component={EndQuiz} />
          {/* New flow */}
          <Route path={PATH_URL.NEW_COLOR_PALETTE_PAGE} component={ColorPalettePage} />
          <Route path={PATH_URL.NEW_AVAILABILITY_PAGE} component={NewAvailabilityPage} />
          <Route path={PATH_URL.YOUR_DETAILS} component={YourDetailsPage} />
          <Route path={PATH_URL.PLANNING_STAGE} component={NewPlanningStagePage} />
          <Route path={PATH_URL.GUEST_COUNT} component={GuestCountPage} />
          <Route path={PATH_URL.NEW_BUDGET_PAGE} component={NewBudgetPage} />
          <Route path={PATH_URL.ESSENTIALS_COLLECTION_PAGE} component={EssentialsCollectionPage} />
          <Route path={PATH_URL.CONTACT_INFO} component={ContactInfoPage} />
          {/* Pinterest flow */}
          <Route path={PATH_URL.PINTEREST_AVAILABILITY} component={PinterestAvailabilityPage} />
          <Route path={PATH_URL.PINTEREST_LINK_YOUR_BOARD} component={PinterestLinkYourBoardPage} />
          <Route path={PATH_URL.PINTEREST_BOARD} component={PinterestBoardPage} />
          <Route path={PATH_URL.IMPORT_PINS} component={PinterestImportPinsPage} />
        </Switch>
      </AssetPreload>
    </QuizQuestionContext.Provider>
  )
}
